import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { PlatformService } from '@core/services';
import { ChangableComponent } from '@models/changable.component';

@Component({
  selector: 'loading-line',
  template: `
    <div [ngStyle]="{ width: width, height: height }">
      <div
        *ngIf="isShowMessage"
        style="text-align: center; width: 100%"
        [innerHTML]="'loading-line.text' | translate"></div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        style="margin: auto; shape-rendering: auto;"
        width="100%"
        [attr.height]="height"
        viewBox="0 0 100 100"
        preserveAspectRatio="xMidYMid">
        <g transform="translate(20 50)">
          <circle cx="0" cy="0" r="6" fill="#109ad7">
            <animateTransform
              attributeName="transform"
              type="scale"
              begin="-0.375s"
              calcMode="spline"
              keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
              values="0;1;0"
              keyTimes="0;0.5;1"
              dur="1s"
              repeatCount="indefinite"></animateTransform>
          </circle>
        </g>
        <g transform="translate(40 50)">
          <circle cx="0" cy="0" r="6" fill="#fdfdfe">
            <animateTransform
              attributeName="transform"
              type="scale"
              begin="-0.25s"
              calcMode="spline"
              keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
              values="0;1;0"
              keyTimes="0;0.5;1"
              dur="1s"
              repeatCount="indefinite"></animateTransform>
          </circle>
        </g>
        <g transform="translate(60 50)">
          <circle cx="0" cy="0" r="6" fill="#109ad7">
            <animateTransform
              attributeName="transform"
              type="scale"
              begin="-0.125s"
              calcMode="spline"
              keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
              values="0;1;0"
              keyTimes="0;0.5;1"
              dur="1s"
              repeatCount="indefinite"></animateTransform>
          </circle>
        </g>
        <g transform="translate(80 50)">
          <circle cx="0" cy="0" r="6" fill="#fdfdfe">
            <animateTransform
              attributeName="transform"
              type="scale"
              begin="0s"
              calcMode="spline"
              keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
              values="0;1;0"
              keyTimes="0;0.5;1"
              dur="1s"
              repeatCount="indefinite"></animateTransform>
          </circle>
        </g>
        <!-- [ldio] generated by https://loading.io/ -->
      </svg>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
// tslint:disable-next-line:component-class-suffix
export class LoadingLine extends ChangableComponent implements OnInit {
  @Input() width: string;
  @Input() height: string;

  public isShowMessage = false;

  constructor(protected readonly cdr: ChangeDetectorRef, protected readonly platform: PlatformService) {
    super(cdr, platform);
  }

  ngOnInit(): void {
    this.onBrowserOnly(() => {
      this.setTimeout(() => {
        this.isShowMessage = true;
        this.detectChanges();
      }, 5000);
    });
  }
}
